module.exports = __webpack_public_path__ + "img/orange.0eff6ee2.jpeg";